import Card from 'components/Card/Card';
import { EditText } from 'components/EditText/EditText';
import { ColorDialog } from '../../../../components/Dialog/Dialog';
import { useState } from 'react';

const CustomApp = (props) => {
    const [showPicker, setShowPicker] = useState(false);
    const { customApp, isEditing, onToggle, setCustomApp } = props;
    return (
        <Card title="Custom App" editing={isEditing} onToggle={onToggle}>
            <EditText
                label={'Identifier'}
                onChange={(val) => setCustomApp('id', val)}
                value={customApp ? customApp.id : ''}
                editing={isEditing}
            />
            <p>Warning, here be dragons! The Identifier above needs to be unique, it's used by the web app to work out what image appears on the right of the login. So name this carefully.</p>
            <EditText
                label={'Bundle ID'}
                onChange={(val) => setCustomApp('bundle_id', val)}
                value={customApp ? customApp.bundle_id : ''}
                editing={isEditing}
            />
            <EditText
                label={'Title'}
                onChange={(val) => setCustomApp('title', val)}
                value={customApp ? customApp.title : ''}
                editing={isEditing}
            />
            <EditText
                label={'Website Subdomain'}
                onChange={(val) => setCustomApp('website_url', val)}
                value={customApp ? customApp.website_url : ''}
                editing={isEditing}
            />
            <EditText
                label={'Login Slug'}
                onChange={(val) => setCustomApp('slug', val)}
                value={customApp ? customApp.slug : ''}
                editing={isEditing}
            />
            <div onClick={() => isEditing && setShowPicker(!showPicker)}>
                <EditText
                    label={'Primary Colour'}
                    value={customApp?.primary_color || '#0F2B41'}
                    editing={isEditing}
                />
            </div>
            {showPicker ? (
                <ColorDialog
                    title="Select color"
                    hexValOfColor={customApp?.primary_color || '#0F2B41'}
                    onSetColor={(hexVal) => {
                        setShowPicker(false);
                        setCustomApp('primary_color', hexVal);
                    }}
                    onClose={() => {
                        setShowPicker(false);
                    }}
                />
            ) : null}
            <EditText
                label={'Primary Font'}
                onChange={(val) => setCustomApp('primary_font', val)}
                value={customApp ? customApp.primary_font : ''}
                editing={isEditing}
            />
        </Card>
    );
};

export default CustomApp;
